import React, { useState } from "react";
import { AnalyticsEvents, trackEvent } from "helpers/analytics/analytics";

const MeetFaq = ({ items }) => {
  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (index, question) => {
    setOpenIndex((current) => {
      const isOpen = current === index;
      const next = isOpen ? -1 : index;
      trackEvent(AnalyticsEvents.MEET_FAQ, {
        item_name: question,
        location: "meet_page",
        label: isOpen ? "collapse" : "expand",
      });
      return next;
    });
  };

  return (
    <div className="meet-x__faq-list">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div
            key={item.q}
            className={`meet-x__faq-item ${isOpen ? "is-open" : ""}`}
          >
            <button
              type="button"
              className="meet-x__faq-trigger"
              aria-expanded={isOpen}
              onClick={() => handleToggle(index, item.q)}
            >
              <span>{item.q}</span>
              <span className="meet-x__faq-icon" aria-hidden="true" />
            </button>
            {isOpen && (
              <div className="meet-x__faq-answer">
                <p>{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MeetFaq;
